import ENDPOINT from "@/api/endpoints";
import { HTTP, buildQueries } from "@/api/http-common";

export function callApiLayDanhSachTemplate(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.post(`${ENDPOINT.QUAN_TRI_HE_THONG.TEMPLATE.GET_ALL}`, payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiLayChiTietTemplate(templateId) {
  return new Promise((resolve, reject) => {
    return HTTP.get(
      `${ENDPOINT.QUAN_TRI_HE_THONG.TEMPLATE.CHI_TIET}?templateId=${templateId}`
    )
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiThemMoiTemplate(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.post(`${ENDPOINT.QUAN_TRI_HE_THONG.TEMPLATE.THEM_MOI}`, payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiSuaTemplate(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.post(`${ENDPOINT.QUAN_TRI_HE_THONG.TEMPLATE.SUA}`, payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiXoaTemplate(templateId) {
  return new Promise((resolve, reject) => {
    return HTTP.post(
      `${ENDPOINT.QUAN_TRI_HE_THONG.TEMPLATE.XOA}?templateId=${templateId}`
    )
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiLayDanhSachQuanLyHeThongLog(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.post(
      `${ENDPOINT.QUAN_TRI_HE_THONG.GET_DANH_SACH_QUAN_LY_HE_THONG_LOG}`,
      payload
    )
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiLayDanhSachDanhMucCRUD(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.get(
      `${ENDPOINT.QUAN_TRI_HE_THONG.GET_DANH_SACH_DANH_MUC_CRUD}`,
      payload
    )
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiLayDanhSachDanhMucCRUDByCode(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.post(
      `${ENDPOINT.QUAN_TRI_HE_THONG.GET_DANH_SACH_DANH_MUC_CRUD_BY_CODE}`,
      payload
    )
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiTaoMoiDanhMucCRUDByCode(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.post(
      `${ENDPOINT.QUAN_TRI_HE_THONG.THEM_MOI_DANH_MUC_CRUD_BY_CODE}`,
      payload
    )
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiXoaDanhMucCRUDByCode(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.post(
      `${ENDPOINT.QUAN_TRI_HE_THONG.XOA_DANH_MUC_CRUD_BY_CODE}`,
      payload
    )
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiSuaDanhMucCRUDByCode(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.post(
      `${ENDPOINT.QUAN_TRI_HE_THONG.SUA_DANH_MUC_CRUD_BY_CODE}`,
      payload
    )
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiLayDanhSachDonViNgoaiPaging(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.get(
      `${
        ENDPOINT.QUAN_TRI_HE_THONG.DON_VI_NGOAI
          .GET_DANH_SACH_DON_VI_NGOAI_PAGING
      }?${buildQueries(payload)}`
    )
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiLayDanhSachDonViNgoai() {
  return new Promise((resolve, reject) => {
    return HTTP.get(
      `${ENDPOINT.QUAN_TRI_HE_THONG.DON_VI_NGOAI.GET_DANH_SACH_DON_VI_NGOAI}`
    )
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiTaoDonViNgoai(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.post(
      ENDPOINT.QUAN_TRI_HE_THONG.DON_VI_NGOAI.THEM_DON_VI_NGOAI,
      payload
    )
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiSuaDonViNgoai(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.put(
      ENDPOINT.QUAN_TRI_HE_THONG.DON_VI_NGOAI.SUA_DON_VI_NGOAI,
      payload
    )
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiXoaDonViNgoai(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.delete(
      `${ENDPOINT.QUAN_TRI_HE_THONG.DON_VI_NGOAI.XOA_DON_VI_NGOAI}/${payload}`
    )
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
